function toastError(message) {
    throw new Error(`[Toast Service]: ${message}`);
}
function createToastService() {
    const closeAllListeners = new Set();
    const closeListeners = new Set();
    const listeners = new Set();
    const addCloseAllListener = (fn) => {
        if (closeAllListeners.has(fn)) {
            toastError('This listener is already listening to close events.');
        }
        closeAllListeners.add(fn);
        return () => {
            closeAllListeners.delete(fn);
        };
    };
    const addCloseListener = (fn) => {
        if (closeListeners.has(fn)) {
            toastError('This listener is already listening to close events.');
        }
        closeListeners.add(fn);
        return () => {
            closeListeners.delete(fn);
        };
    };
    const addListener = (fn) => {
        if (listeners.has(fn)) {
            toastError('This listener is already listening to new toasts.');
        }
        listeners.add(fn);
        return () => {
            listeners.delete(fn);
        };
    };
    const close = (id) => {
        closeListeners.forEach((listener) => {
            listener(id);
        });
    };
    const closeAll = () => {
        closeAllListeners.forEach((listener) => {
            listener();
        });
    };
    const open = (toast) => {
        listeners.forEach((listener) => {
            listener(toast);
        });
    };
    return {
        addCloseAllListener,
        addCloseListener,
        addListener,
        close,
        closeAll,
        open,
    };
}
const ToastService = createToastService();
export { ToastService, };
//# sourceMappingURL=toast-service.js.map